/**
 * i18n phase: menu-item food hub feed + multi-store cart bar.
 * Tuples are [ko, en, vi, ru].
 */

function pick(obj, langIndex) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  }
  return out;
}

const menuFeed = {
  quickAddBtn: ['담기', 'Add', 'Thêm', 'В корзину'],
  viewFullMenu: ['전체 메뉴 보기', 'View full menu', 'Xem menu đầy đủ', 'Полное меню'],
  cartBarSingleStore: [
    '{name} · {count}개',
    '{name} · {count} items',
    '{name} · {count} món',
    '{name} · {count} шт.',
  ],
  cartBarMultiStore: [
    '{count}개 매장에 담음',
    '{count} stores in cart',
    '{count} cửa hàng trong giỏ',
    '{count} магазинов в корзине',
  ],
  myCartsTitle: ['내 장바구니', 'My carts', 'Giỏ hàng của tôi', 'Мои корзины'],
  storeSplitPolicy: [
    '여러 매장 상품을 담아도 주문은 매장별로 각각 접수됩니다.',
    'Even with multiple stores in cart, checkout is processed per store.',
    'Dù có nhiều cửa hàng trong giỏ, đơn vẫn được đặt riêng theo từng cửa hàng.',
    'Даже при нескольких магазинах заказ оформляется отдельно по каждому магазину.',
  ],
  orderThisStoreBtn: ['이 매장 주문하기', 'Order this store', 'Đặt hàng cửa hàng này', 'Заказать здесь'],
  orderCta: ['주문하기', 'Checkout', 'Đặt hàng', 'Оформить'],
  viewCartsCta: ['장바구니 보기', 'View carts', 'Xem giỏ hàng', 'К корзинам'],
  empty: ['등록된 메뉴가 없습니다', 'No menu items yet', 'Chưa có món nào', 'Меню пока нет'],
  loadMore: ['더 보기', 'Load more', 'Xem thêm', 'Ещё'],
  loading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  cartsEmpty: ['담긴 메뉴가 없습니다', 'Your carts are empty', 'Giỏ hàng trống', 'Корзины пусты'],
  addedToast: ['장바구니에 담았어요 ({count}개)', 'Added to cart ({count})', 'Đã thêm ({count})', 'Добавлено ({count})'],
  errorGeneric: ['처리에 실패했습니다', 'Something went wrong', 'Đã xảy ra lỗi', 'Что-то пошло не так'],
  cuisineGridLabel: ['요리 종류', 'Cuisine', 'Loại món', 'Кухня'],
  cuisineFieldLabel: ['요리 종류', 'Cuisine type', 'Loại món', 'Тип кухни'],
  cuisineFieldHint: [
    '선택하면 허브에서 요리종류별로 찾을 수 있어요 (선택)',
    'Optional — helps shoppers filter by cuisine on the hub',
    'Tuỳ chọn — giúp lọc theo loại món trên hub',
    'Необязательно — помогает фильтровать по кухне',
  ],
  deliveryFeeShort: ['배달비', 'Fee', 'Phí giao', 'Доставка'],
  minOrderShort: ['최소주문', 'Min', 'Tối thiểu', 'Мин. заказ'],
  popularBadge: ['인기', 'Popular', 'Phổ biến', 'Популярное'],
  marketPriceLabel: ['시가', 'Market price', 'Giá thị trường', 'Рыночная цена'],
  weightPriceFormat: [
    '{price} / {base}g',
    '{price} / {base}g',
    '{price} / {base}g',
    '{price} / {base}г',
  ],
  sort: {
    default: ['기본순', 'Default', 'Mặc định', 'По умолчанию'],
    rating: ['별점순', 'Rating', 'Đánh giá', 'По рейтингу'],
    price_low: ['가격낮은순', 'Price: low to high', 'Giá thấp đến cao', 'Цена по возрастанию'],
    price_high: ['가격높은순', 'Price: high to low', 'Giá cao đến thấp', 'Цена по убыванию'],
  },
  cuisine: {
    korean: ['한식', 'Korean', 'Hàn', 'Корейская'],
    chinese: ['중식', 'Chinese', 'Trung', 'Китайская'],
    japanese: ['일식', 'Japanese', 'Nhật', 'Японская'],
    vietnamese: ['베트남식', 'Vietnamese', 'Việt', 'Вьетнамская'],
    western: ['양식', 'Western', 'Âu', 'Европейская'],
    bakery: ['베이커리', 'Bakery', 'Tiệm bánh', 'Пекарня'],
    cafe_dessert: ['카페·디저트', 'Cafe & dessert', 'Cafe & tráng miệng', 'Кафе и десерты'],
    fastfood: ['패스트푸드', 'Fast food', 'Đồ ăn nhanh', 'Фастфуд'],
    bar_snack: ['주류·안주', 'Bar & snacks', 'Đồ nhắm', 'Бар и закуски'],
    other: ['기타', 'Other', 'Khác', 'Другое'],
  },
};

function buildLang(langIndex) {
  return { menuFeed: pick(menuFeed, langIndex) };
}

export const phaseMenuFeedKo = buildLang(0);
export const phaseMenuFeedEn = buildLang(1);
export const phaseMenuFeedVi = buildLang(2);
export const phaseMenuFeedRu = buildLang(3);
